import { ArrowDown, ArrowUp, Trash2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TAnyClientQuestionType } from '@hubertai/screening-question-types';
import type { TRuleEditorCommonProps } from '../types';
import { useQuestion } from 'hooks/useQuestion';
import IsAxiosError from 'components/common/IsAxiosError';

interface Props extends TRuleEditorCommonProps {
  targetId: string;
  renderLanguages: (questionConfig: TAnyClientQuestionType) => ReactNode;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  onRemove: () => void;
}

const RuleActionJumpToTarget = ({ targetId, renderLanguages, isReadOnly, onMoveUp, onMoveDown, onRemove }: Props) => {
  const { t } = useTranslation('Templates');
  const { questionConfig, isLoading, isFetching, isError, error } = useQuestion(targetId);

  if (isLoading || isFetching) return <li className="p-4">{t('question.loading')}</li>;
  if (isError) return <IsAxiosError error={error} />;
  if (!questionConfig) {
    return <li className="p-4 text-red-600">{t('question.ruleActions.questionNotFound', { id: targetId })}</li>;
  }

  return (
    <li className="p-4 hover:bg-slate-100">
      <div className="flex justify-between">
        {renderLanguages(questionConfig)}
        {!isReadOnly ? (
          <div className="flex min-w-[100px] items-center justify-center gap-2">
            {onMoveUp ? <ArrowUp className="h-4 w-4 cursor-pointer" onClick={onMoveUp} /> : null}
            {onMoveDown ? <ArrowDown className="h-4 w-4 cursor-pointer" onClick={onMoveDown} /> : null}
            <Trash2 className="text-danger-400 h-4 w-4 cursor-pointer" onClick={onRemove} />
          </div>
        ) : null}
      </div>
    </li>
  );
};

export default RuleActionJumpToTarget;
